export const categoryData = [
  {
    image: 'image1.png',
    categoryName: 'Furniture',
    description: 'Home furniture',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image2.png',
    categoryName: 'Decor',
    description: 'Home decor items',
    status: 'Inactive',
    action: 'Edit',
  },
  {
    image: 'image3.png',
    categoryName: 'Lighting',
    description: 'Lighting solutions',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image4.png',
    categoryName: 'Bedding',
    description: 'Comfortable bedding',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image5.png',
    categoryName: 'Kitchenware',
    description: 'Essential kitchen items',
    status: 'Inactive',
    action: 'Edit',
  },
];

export const brandData = [
  {
    image: 'image1.png',
    brand: 'IKEA',
    description: 'Modern furniture design',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image2.png',
    brand: 'Wayfair',
    description: 'Home decor and furniture',
    status: 'Inactive',
    action: 'Edit',
  },
  {
    image: 'image3.png',
    brand: 'Philips',
    description: 'Innovative lighting solutions',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image4.png',
    brand: 'Tempur-Pedic',
    description: 'Luxury bedding products',
    status: 'Active',
    action: 'Edit',
  },
  {
    image: 'image5.png',
    brand: 'Tupperware',
    description: 'High-quality kitchen items',
    status: 'Inactive',
    action: 'Edit',
  },
];

// constants.ts
export const categoryTColumns = [
  { header: 'Image', accessor: 'image', className: 'w-[100px] pl-4' },
  { header: 'Category Name', accessor: 'categoryName' },
  { header: 'Description', accessor: 'description' },
  { header: 'Status', accessor: 'status', className: 'text-right' },
  {
    header: 'Action',
    accessor: 'action',
    className: 'text-center ',
  },
];

export const brandsTColumns = [
  { header: 'Image', accessor: 'image', className: 'w-[100px] pl-4' },
  { header: 'Brand', accessor: 'brandName' },
  { header: 'Description', accessor: 'description' },
  { header: 'Status', accessor: 'status', className: 'text-right' },
  { header: 'Action', accessor: 'action', className: 'text-center' },
];

export const productsTColumns = [
  { header: 'Image', accessor: 'image', className: 'w-[100px] pl-4' },
  { header: 'Product Name', accessor: 'productName' },
  { header: 'Keyword', accessor: 'keyword' },
  { header: 'Price', accessor: 'price', className: 'text-right' },
  { header: 'Unit', accessor: 'unit', className: 'text-right' },
  { header: 'Brand', accessor: 'unit', className: 'text-right' },
  { header: 'Status', accessor: 'status', className: 'text-right' },
  { header: 'Qty', accessor: 'qty', className: 'text-right' },
  { header: 'Action', accessor: 'action', className: 'text-center ' },
];

export const statusFilterData = [
  { id: true, name: 'Active' },
  { id: false, name: 'Inactive' },
];

export const categoryTypes = [
  { id: 'main', name: 'Main Category' },
  { id: 'sub', name: 'Sub Category' },
];

export const stockTypes = [
  { id: 'INS_STOCK', name: 'In Stock' },
  { id: 'LOW_STOCK', name: 'Low Stock' },
  { id: 'OUT_STOCK', name: 'Out of Stock' },
];
